// import React, { useEffect, useState } from "react";
// import "./HRExecutiveTabl.css";
// import {
//   Box,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   IconButton,
//   Button,
//   Modal,
//   TextField,
//   MenuItem,
// } from "@mui/material";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CloseIcon from "@mui/icons-material/Close";

// const months = [
//   "January","February","March","April","May","June",
//   "July","August","September","October","November","December"
// ];

// const HRExecutiveTable = () => {
//   const [data, setData] = useState([]);
//   const [error, setError] = useState(false);
//   const [viewData, setViewData] = useState(null);
//   const [editData, setEditData] = useState(null);

//   const [year, setYear] = useState("");
//   const [month, setMonth] = useState("");

//   /* ======================
//      FETCH HR EXECUTIVE DATA
//   ====================== */
//   useEffect(() => {
//     fetch("https://dummyjson.com/users")
//       .then((res) => {
//         if (!res.ok) throw new Error("Fetch failed");
//         return res.json();
//       })
//       .then((res) => {
//         const mapped = res.users.slice(0, 10).map((u, i) => ({
//           id: u.id,
//           employeeId: `HR-${1000 + i}`,
//           name: `${u.firstName} ${u.lastName}`,
//           contactNumber: u.phone,
//           email: u.email,
//           department: "HR",
//           role: "HR Executive",
//           joiningDate: "2025-02-10",
//           status: "Active",
//         }));
//         setData(mapped);
//       })
//       .catch(() => setError(true));
//   }, []);

//   /* ======================
//      FILTER LOGIC
//   ====================== */
//   const filteredData = data.filter((row) => {
//     if (!row.joiningDate) return true;
//     const d = new Date(row.joiningDate);
//     const yMatch = year ? d.getFullYear().toString() === year : true;
//     const mMatch = month ? d.getMonth() === Number(month) : true;
//     return yMatch && mMatch;
//   });

//   /* ======================
//      VIEW / EDIT / DELETE HANDLERS
//   ====================== */
//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this record?")) {
//       setData((prev) => prev.filter((d) => d.id !== id));
//     }
//   };

//   const handleEditChange = (field, value) => {
//     setEditData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleEditSave = () => {
//     setData((prev) =>
//       prev.map((row) => (row.id === editData.id ? editData : row))
//     );
//     setEditData(null);
//   };

//   return (
//     <Box className="hr-wrapper">
//       {/* HEADER */}
//       <Box className="hr-header">
//         <h2>HR Executive Profiles</h2>

//         <div className="header-controls">
//           {/* FILTERS */}
//           <div className="filters">
//             <TextField
//               select
//               size="small"
//               label="Year"
//               value={year}
//               onChange={(e) => setYear(e.target.value)}
//             >
//               <MenuItem value="">All</MenuItem>
//               {[2024, 2025, 2026].map((y) => (
//                 <MenuItem key={y} value={y}>{y}</MenuItem>
//               ))}
//             </TextField>

//             <TextField
//               select
//               size="small"
//               label="Month"
//               value={month}
//               onChange={(e) => setMonth(e.target.value)}
//             >
//               <MenuItem value="">All</MenuItem>
//               {months.map((m, i) => (
//                 <MenuItem key={i} value={i}>{m}</MenuItem>
//               ))}
//             </TextField>
//           </div>
//         </div>
//       </Box>

//       {/* TABLE */}
//       <Paper className="hr-table-wrapper">
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               <TableCell>S.NO</TableCell>
//               <TableCell>Employee ID</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Contact</TableCell>
//               <TableCell>Email</TableCell>
//               <TableCell>Department</TableCell>
//               <TableCell>Role</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {error ? (
//               <TableRow>
//                 <TableCell colSpan={9} align="center" className="error-text">
//                   Failed to fetch data
//                 </TableCell>
//               </TableRow>
//             ) : filteredData.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={9} align="center">
//                   No records found
//                 </TableCell>
//               </TableRow>
//             ) : (
//               filteredData.map((row, index) => (
//                 <TableRow key={row.id}>
//                   <TableCell>{index + 1}</TableCell>
//                   <TableCell>{row.employeeId}</TableCell>
//                   <TableCell>{row.name}</TableCell>
//                   <TableCell>{row.contactNumber}</TableCell>
//                   <TableCell>{row.email}</TableCell>
//                   <TableCell>{row.department}</TableCell>
//                   <TableCell>{row.role}</TableCell>
//                   <TableCell>
//                     <span className={`status ${row.status.toLowerCase()}`}>
//                       {row.status}
//                     </span>
//                   </TableCell>
//                   <TableCell>
//                     <IconButton onClick={() => setViewData(row)}>
//                       <VisibilityIcon />
//                     </IconButton>
//                     <IconButton onClick={() => setEditData(row)}>
//                       <EditIcon />
//                     </IconButton>
//                     <IconButton onClick={() => handleDelete(row.id)}>
//                       <DeleteIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </Paper>

//       {/* VIEW MODAL */}
//       <Modal open={!!viewData} onClose={() => setViewData(null)}>
//         <Box className="hr-modal">
//           <div className="modal-header">
//             <h3>HR Executive Details</h3>
//             <IconButton onClick={() => setViewData(null)}>
//               <CloseIcon />
//             </IconButton>
//           </div>
//           {viewData && (
//             <div className="view-grid">
//               {Object.entries(viewData).map(([k, v]) =>
//                 k !== "id" ? (
//                   <div key={k}>
//                     <span>{k.replace(/([A-Z])/g, " $1")}</span>
//                     <p>{v}</p>
//                   </div>
//                 ) : null
//               )}
//             </div>
//           )}
//         </Box>
//       </Modal>

//       {/* EDIT MODAL */}
//       <Modal open={!!editData} onClose={() => setEditData(null)}>
//         <Box className="hr-modal">
//           <div className="modal-header">
//             <h3>Edit HR Executive</h3>
//             <IconButton onClick={() => setEditData(null)}>
//               <CloseIcon />
//             </IconButton>
//           </div>
//           {editData && (
//             <div className="edit-grid">
//               {["employeeId", "name", "contactNumber", "email", "department", "role", "status"].map((field) => (
//                 <TextField
//                   key={field}
//                   label={field.replace(/([A-Z])/g, " $1")}
//                   value={editData[field]}
//                   onChange={(e) => handleEditChange(field, e.target.value)}
//                   fullWidth
//                   margin="dense"
//                   size="small"
//                 />
//               ))}
//               <Button
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 onClick={handleEditSave}
//                 style={{ marginTop: "15px" }}
//               >
//                 Save Changes
//               </Button>
//             </div>
//           )}
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default HRExecutiveTable;


import React, { useEffect, useState } from "react";
import "./HRExecutiveTabl.css";
import {
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Modal,
  TextField,
  MenuItem,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";

const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

const HRExecutiveTable = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [editData, setEditData] = useState(null);

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  /* ======================
     FETCH HR EXECUTIVE DATA
  ====================== */
  useEffect(() => {
    fetch("https://dummyjson.com/users")
      .then((res) => {
        if (!res.ok) throw new Error("Fetch failed");
        return res.json();
      })
      .then((res) => {
        // Only 4 dummy rows
        const mapped = res.users.slice(0, 4).map((u, i) => ({
          id: u.id,
          employeeId: `HR-${1000 + i}`,
          name: `${u.firstName} ${u.lastName}`,
          contactNumber: u.phone,
          email: u.email,
          department: "HR",
          role: "HR Executive",
          joiningDate: "2025-02-10",
          status: "Active",
        }));
        setData(mapped);
      })
      .catch(() => setError(true));
  }, []);

  /* ======================
     FILTER LOGIC
  ====================== */
  const filteredData = data.filter((row) => {
    if (!row.joiningDate) return true;
    const d = new Date(row.joiningDate);
    const yMatch = year ? d.getFullYear().toString() === year : true;
    const mMatch = month ? d.getMonth() === Number(month) : true;
    return yMatch && mMatch;
  });

  /* ======================
     VIEW / EDIT / DELETE HANDLERS
  ====================== */
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      setData((prev) => prev.filter((d) => d.id !== id));
    }
  };

  const handleEditChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditSave = () => {
    setData((prev) =>
      prev.map((row) => (row.id === editData.id ? editData : row))
    );
    setEditData(null);
  };

  /* ======================
     EXPORT CSV
  ====================== */
  const handleExport = () => {
    if (filteredData.length === 0) return;
    const header = Object.keys(filteredData[0]).join(",");
    const rows = filteredData.map((row) => Object.values(row).join(","));
    const csv = [header, ...rows].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "HR_Executives.csv";
    a.click();
  };

  /* ======================
     IMPORT CSV
  ====================== */
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const lines = evt.target.result.split("\n").filter(Boolean);
      const headers = lines[0].split(",");

      const rows = lines.slice(1).map((line, i) => {
        const values = line.split(",");
        let obj = { id: Date.now() + i };
        headers.forEach((h, index) => {
          obj[h.trim()] = values[index];
        });
        return obj;
      });

      setData((prev) => [...prev, ...rows]);
    };
    reader.readAsText(file);
  };

  return (
    <Box className="hr-wrapper">
      {/* HEADER */}
      <Box className="hr-header">
        <h2>HR Executive Profiles</h2>

        <div className="header-controls">
          {/* FILTERS */}
          <div className="filters">
            <TextField
              select
              size="small"
              label="Year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              {[2024, 2025, 2026].map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </TextField>

            <TextField
              select
              size="small"
              label="Month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              {months.map((m, i) => (
                <MenuItem key={i} value={i}>{m}</MenuItem>
              ))}
            </TextField>
          </div>

          {/* IMPORT / EXPORT */}
          <div className="header-actions">
            <Button component="label" startIcon={<UploadFileIcon />}>
              Import
              <input hidden type="file" accept=".csv" onChange={handleImport} />
            </Button>

            <Button startIcon={<DownloadIcon />} onClick={handleExport}>
              Export
            </Button>
          </div>
        </div>
      </Box>

      {/* TABLE */}
      <Paper className="hr-table-wrapper">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>S.NO</TableCell>
              <TableCell>Employee ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Department</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {error ? (
              <TableRow>
                <TableCell colSpan={9} align="center" className="error-text">
                  Failed to fetch data
                </TableCell>
              </TableRow>
            ) : filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              filteredData.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.employeeId}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.contactNumber}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.department}</TableCell>
                  <TableCell>{row.role}</TableCell>
                  <TableCell>
                    <span className={`status ${row.status.toLowerCase()}`}>
                      {row.status}
                    </span>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => setViewData(row)}>
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton onClick={() => setEditData(row)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(row.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* VIEW MODAL */}
      <Modal open={!!viewData} onClose={() => setViewData(null)}>
        <Box className="hr-modal">
          <div className="modal-header">
            <h3>HR Executive Details</h3>
            <IconButton onClick={() => setViewData(null)}>
              <CloseIcon />
            </IconButton>
          </div>
          {viewData && (
            <div className="view-grid">
              {Object.entries(viewData).map(([k, v]) =>
                k !== "id" ? (
                  <div key={k}>
                    <span>{k.replace(/([A-Z])/g, " $1")}</span>
                    <p>{v}</p>
                  </div>
                ) : null
              )}
            </div>
          )}
        </Box>
      </Modal>

      {/* EDIT MODAL */}
      <Modal open={!!editData} onClose={() => setEditData(null)}>
        <Box className="hr-modal">
          <div className="modal-header">
            <h3>Edit HR Executive</h3>
            <IconButton onClick={() => setEditData(null)}>
              <CloseIcon />
            </IconButton>
          </div>
          {editData && (
            <div className="edit-grid">
              {["employeeId", "name", "contactNumber", "email", "department", "role", "status"].map((field) => (
                <TextField
                  key={field}
                  label={field.replace(/([A-Z])/g, " $1")}
                  value={editData[field]}
                  onChange={(e) => handleEditChange(field, e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              ))}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleEditSave}
                style={{ marginTop: "15px" }}
              >
                Save Changes
              </Button>
            </div>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default HRExecutiveTable;

